export default __webpack_public_path__ + "80fc7ea9880692fe84bcff914e54be60.png";